import type { MfgPricingLayerColumn, MfgPricingLayerGridRow } from "@/lib/manufacturing/types";
import { unattachedColumnPreviews } from "@/lib/manufacturing/cogsUnattachedColumnVariance";
import { SHELF_VARIANCE_TONE } from "./PricingBandTotalCell";
import { formatUsd } from "./pricingGridFormat";

const BAND_LABEL = { cogs: "COGS", wholesale: "Wholesale", msrp: "MSRP" };

export function PricingUnattachedColumnVariance({
  row,
  columns,
}: {
  row: MfgPricingLayerGridRow;
  columns: readonly MfgPricingLayerColumn[];
}) {
  const previews = unattachedColumnPreviews(row, columns);
  return (
    <div className="mt-3">
      <h3 className="text-xs font-semibold uppercase tracking-wide text-gray-500 dark:text-zinc-400">Not on the grid</h3>
      {previews.length === 0 ? (
        <p className="mt-1 text-xs text-gray-500 dark:text-zinc-400">Every saved column is on the grid.</p>
      ) : (
        <table className="mt-1 w-full text-left text-xs">
          <thead>
            <tr className="text-[11px] uppercase tracking-wide text-gray-500 dark:text-zinc-400">
              <th className="py-1 pr-2 font-semibold">Column</th>
              <th className="py-1 pr-2 text-right font-semibold">Amount</th>
              <th className="py-1 pr-2 text-right font-semibold">Wholesale</th>
              <th className="py-1 text-right font-semibold">MSRP</th>
            </tr>
          </thead>
          <tbody>
            {previews.map((preview) => (
              <tr key={preview.column_id} className="border-t border-gray-200 dark:border-zinc-800" title={preview.note}>
                <td className="py-1 pr-2">
                  <div>{preview.label}</div>
                  <div className="text-[10px] text-gray-500 dark:text-zinc-400">{BAND_LABEL[preview.band]}</div>
                </td>
                <td className="py-1 pr-2 text-right tabular-nums">{formatUsd(preview.amount_usd)}</td>
                <td className={`py-1 pr-2 text-right ${SHELF_VARIANCE_TONE[preview.wholesale.tone]}`}>
                  <div className="tabular-nums text-gray-800 dark:text-zinc-200">{formatUsd(preview.wholesale_total_usd)}</div>
                  <div>{preview.wholesale.label}</div>
                </td>
                <td className={`py-1 text-right ${SHELF_VARIANCE_TONE[preview.msrp.tone]}`}>
                  <div className="tabular-nums text-gray-800 dark:text-zinc-200">{formatUsd(preview.msrp_total_usd)}</div>
                  <div>{preview.msrp.label}</div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}
